import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';

export default function useCurrency() {
	return useSelector((state: RootState) => state.currency);
}
